import React, { useState } from 'react'
import { Box, Stack } from '@mui/material'
import { OpenFooter } from './Footer/OpenFooter'
import { ClosedFooter } from './Footer/ClosedFooter'
import { Logo } from '../components/Logo'
import CloseIcon from '@mui/icons-material/Close'

const Footer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [isFooterOpen, setIsFooterOpen] = useState(false)

  return (
    <Stack
      height={isFooterOpen ? { xs: 370, sm: 340, md: 232 } : 45}
      sx={{ transition: 'height 400ms' }}
      color="common.white"
      bgcolor="common.black"
      direction="row"
      pt={isFooterOpen ? 4 : 1.5}
      pb={1.5}
      px={{ xs: 2, lg: 4 }}
      position="relative"
    >
      {isFooterOpen && (
        <Stack
          position="absolute"
          right={32}
          top={12}
          onClick={() => setIsFooterOpen(false)}
          sx={{ cursor: 'pointer' }}
        >
          <CloseIcon />
        </Stack>
      )}
      <Box>
        <Logo width={{ xs: 120, md: 100 }} />
      </Box>

      <Stack flex={1}>
        {isFooterOpen && <OpenFooter />}
        <ClosedFooter
          isFooterOpen={isFooterOpen}
          setIsFooterOpen={setIsFooterOpen}
        />
      </Stack>
    </Stack>
  )
}

export { Footer }
